export const Routes = {
  Home: '/jobs',
  Jobs: '/jobs',
  Companies: '/companies',
  Settings: '/settings',

  // Settings
  SettingsAccounts: '/settings',
  SettingsAppliedJobs: '/settings/applied-jobs',
  SettingsSavedJobs: '/settings/saved-jobs',
};
